import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'

import { Modal, Form, Input, Button, Spin, Select, message, Switch,Space,InputNumber } from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: {span: 5},
    sm: {span: 24},
  },
  wrapperCol: {
    md: {span: 16},
  },
}

const formTailLayout = {
  wrapperCol: {
    md: {offset: 5, span: 16},
  },
}

const {TextArea} = Input
const {Option} = Select

export default function UserAddModal (props) {
  const {visible, onOk, onCancel} = props
  const metadata = useSelector(state => state.metadata.value);
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    (async () => {
      try {

      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const data = {
        type:values.type,
        email:values.email,
        name:values.name,
        fullName:values.fullName,
        password:values.password
      };
      await ToolRequest.request('POST', '/user', data);
      message.success(I18n.t('addSuccessMessage'))
      onOk()
      setLoading(false)
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        switch (err.response.data) {
          case 'DUPLICATE_EMAIL': {
            return message.error('郵箱重覆')
          }
          case 'DUPLICATE_PHONE': {
            return message.error('電話重覆')
          }
          case 'DUPLICATE_NAME': {
            return message.error('登錄名重覆')
          }
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      }

      message.error(I18n.t('errorMessageUnknownError'))
    }
  }

  return (
    <Modal
      title={I18n.t('添加用戶')}
      visible={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
            initialValues={{
              locale: 'zh-tw',
              type:'SERVICE_ADMIN_USER'
            }}
            onFinish={onFinish}
          >
            <Form.Item
              label={I18n.t('用戶類型')}
              name="type"
              rules={[
                {
                  required: true
                },
              ]}
            >
              <Select placeholder={I18n.t('用戶類型')}>
                <Option value="SERVICE_ADMIN_USER">
                  {I18n.t('管理員')}
                </Option>
              </Select>
            </Form.Item>
            <Form.Item
              label={I18n.t('郵箱')}
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: I18n.t('errorMessageRequiredInputAny', {
                    name: `${I18n.t('郵箱')}`,
                  }),
                },
              ]}
            >
              <Input
                placeholder={I18n.t('郵箱')}
              />
            </Form.Item>
            <Form.Item
                label={I18n.t('POS登錄名')}
                name="name"
            >
              <Input
                  placeholder={I18n.t('POS登錄名')}
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('全名')}
              name="fullName"
            >
              <Input
                placeholder={I18n.t('全名')}
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('密碼')}
              name="password"
              rules={[
                {
                  required: true,
                  message: I18n.t('errorMessageRequiredInputAny', {
                    name: I18n.t('密碼'),
                  }),
                },
              ]}
            >
              <Input type="password" placeholder={I18n.t('密碼')} />
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull/>}
    </Modal>
  )
};